import loadable from '@loadable/component';

// 懒加载组件
const SupHospitalManagement = loadable(() => import('./supHospitalManagement/SupHospitalManagement'));
const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));
const ItemPriceRequestManagement = loadable(() => import('./itemPriceRequestManagement/ItemPriceRequestManagement'));
const ItemPriceRequestDetailModify = loadable(() => import('./itemPriceRequestManagement/itemPriceRequestDetailModify/ItemPriceRequestDetailModify'));
const HospitalInventoryQuery = loadable(() => import('./hospitalInventoryQuery/HospitalInventoryQuery'));
const ShortageManagement = loadable(() => import('./shortageManagement/ShortageManagement'));
const ItemApplication = loadable(() => import('./itemNewApplication/ItemApplication'));
const ItemLicenseNewApplication = loadable(() => import('./itemLicenseNewApplication/ItemLicenseNewApplication'));
const ItemLicenseNewWithUpstreamApplication = loadable(() => import('./itemLicenseNewWithUpstreamApplication/ItemLicenseNewWithUpstreamApplication'));
const ItemLicenseApplication = loadable(() => import('./itemNewApplicationWithSelection/ItemLicenseApplication'));
const ItemDictionaryRequestManagement = loadable(() => import('./itemDictionaryRequestManagement/ItemDictionaryRequestManagement'));
const HosItemPriceWithUpstreamManagement = loadable(() => import('./hosItemPriceWithUpstreamManagement/HosItemPriceWithUpstreamManagement'));
const HosWarehouseInventoryQuery = loadable(() => import('./hosWarehouseInventoryQuery/HosWarehouseInventoryQuery'));
const HospitalInventoryDetailQuery = loadable(() => import('./hospitalInventoryDetailQuery/HospitalInventoryDetailQuery'));
const ItemActiveEnableQuestion = loadable(() => import('./itemActiveEnableQuestion/ItemActiveEnableQuestion'));
const ItemActiveDisableQuestion = loadable(() => import('./itemActiveDisableQuestion/ItemActiveDisableQuestion'));
const ItemPriceHistoryQuery = loadable(() => import('./itemPriceHistoryQuery/ItemPriceHistoryQuery'));
const HosWarehouseLevelOneInventoryQuery = loadable(() => import('./hosWarehouseLevelOneInventoryQuery/HosWarehouseLevelOneInventoryQuery'));
const ItemCatalogQuery = loadable(() => import('./itemCatalogQuery/ItemCatalogQuery'));

export const subRoutes = [
  {
    path: '/SupHospitalManagement',
    component: SupHospitalManagement
  },
  {
    path: '/HospitalInventoryQuery',
    component: HospitalInventoryQuery
  },
  {
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  },
  {
    path: '/HosItemPriceWithUpstreamManagement',
    component: HosItemPriceWithUpstreamManagement
  },
  {
    path: '/ItemPriceRequestDetailModify',
    component: ItemPriceRequestDetailModify
  },
  {
    path: '/ItemPriceRequestManagement',
    component: ItemPriceRequestManagement
  },
  {
    path: '/ShortageManagement',
    component: ShortageManagement
  },
  {
    path: '/ItemNewApplication',
    component: ItemApplication
  },
  {
    path: '/ItemLicenseNewApplication',
    component: ItemLicenseNewApplication
  },
  {
    path: '/ItemLicenseNewWithUpstreamApplication',
    component: ItemLicenseNewWithUpstreamApplication
  },
  {
    path: '/ItemNewApplicationWithSelection',
    component: ItemLicenseApplication
  },
  {
    path: '/ItemDictionaryRequestManagement',
    component: ItemDictionaryRequestManagement
  },
  {
    path: '/HosWarehouseInventoryQuery',
    component: HosWarehouseInventoryQuery
  },
  {
    path: '/HospitalInventoryDetailQuery',
    component: HospitalInventoryDetailQuery
  },
  {
    path: '/ItemActiveEnableQuestion',
    component: ItemActiveEnableQuestion
  },
  {
    path: '/ItemActiveDisableQuestion',
    component: ItemActiveDisableQuestion
  },
  {
    path: '/ItemPriceHistoryQuery',
    component: ItemPriceHistoryQuery
  },
  {
    path: '/HosWarehouseLevelOneInventoryQuery',
    component: HosWarehouseLevelOneInventoryQuery
  },
  {
    path: '/ItemCatalogQuery',
    component: ItemCatalogQuery
  }
];
